<template>
    <li class="betshops__shops-list-item">
        <i class="icon--md icon-location betshops__shops-list-item--icon"></i>
        <div class="betshops__shops-list-item--details">
            <div class="city">{{ city }}</div>
            <div class="address">{{ address }}</div>
            <div class="work-hours">
                <span class="work-hours--label">
                    {{ $t('hours') | capitalize }}:
                </span>
                <span class="work-hours--time">
                    {{ openingHour }} - {{ closingHour }}
                </span>
            </div>
        </div>
    </li>
</template>

<script>

    export default {
        name: 'ShopInfo',
        props: {
            city: {
                type: String,
                required: false,
                default: '-'
            },
            address: {
                type: String,
                required: true,
            },
            openingHour: {
                type: String,
                required: true,
            },
            closingHour: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/app/modules/country/shops/components/ShopInfo.vue